import axios from "axios";
import store from "../store/store"; // import default store
// import { refreshToken } from "./authAPI"; // your thunk or plain function
import { setToken } from "../slices/authSlice";
import { setUser } from "../slices/profileSlice";

export const axiosInstance = axios.create({
  withCredentials: true, // always send cookies
});

// Response interceptor for 401 handling
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // If request failed with 401 and we haven’t retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // Call refresh endpoint directly
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/auth/refresh-token`,
          { withCredentials: true }
        );

        if (res.data?.success && res.data?.accessToken) {
          // Update Redux state
          const userImage = res.data.user?.image
            ? res.data.user.image
            : `https://api.dicebear.com/5.x/initials/svg?seed=${res.data.user.firstName} ${res.data.user.lastName}`;

          store.dispatch(setToken(res.data.accessToken));
          store.dispatch(setUser({ ...res.data.user, image: userImage }));

          // Retry the original request with new token if needed
          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        console.error("REFRESH TOKEN FAILED", refreshError);
        store.dispatch(setToken(null));
        store.dispatch(setUser(null));
      }
    }

    return Promise.reject(error);
  }
);

// Reusable API wrapper
export const apiConnector = async (method, url, bodyData, headers, params) => {
  // console.log("API CALL:", method, url, bodyData);
  const response = await axiosInstance({
    method,
    url,
    data: bodyData || null,
    headers: headers || null,
    params: params || null,
  });
  return response.data;
};
